/*
 * Author: Roger
 * File Created: Thursday, 24-08-01 02:01 pm
 * Last Modified: Wednesday, 25-07-23 06:44 pm, by Dw
 */
import type { CustomAxiosRequestConfig } from '@web/http';
import { clearCache, get } from '@web/http';

import type {
  Transaction,
  TransactionDetail,
  UserAssetDetail,
  UserNetworkAsset,
} from '@/@types/asset';

export const getUserAssetDetail = async (
  req?: CustomAxiosRequestConfig['req'],
) => {
  return get<UserAssetDetail>(`/gateway/user-asset/private/v1`, {}, { req });
};

const CRYPTO_TRANS_URL = '/gateway/user-asset/private/v1/transactions';

export const clearCryptoTrans = () => {
  clearCache(CRYPTO_TRANS_URL);
};

export const getUserTransactions = async (_params: {
  start: number;
  end: number;
  page: number;
  size: number;
  force?: boolean;
}) => {
  const { force, ...resParams } = _params;

  return get<Transaction[] | undefined>(CRYPTO_TRANS_URL, resParams, {
    cacheConfig: {
      useCache: !force,
    },
  });
};

export const getUserTransactionDetail = async (_params: {
  tranId: string;
  externalTranId: string;
  type: string;
}) => {
  return get<TransactionDetail>(
    `/gateway/user-asset/private/v1/transaction/detail`,
    _params,
  );
};

export const getUserNetworkAssets = async () => {
  // 这里获取到的是用户所有网络的资产列表，供后续通过asset和network来筛选

  return get<UserNetworkAsset[]>(`/gateway/user-asset/private/v1/network`);
};

export const getQuoteAsset = (data: API.Asset.GetPriceV1Request) => {
  return get<API.Asset.GetPriceV1Response>(
    `/gateway/asset/public/v1/price`,
    {
      quote: data.quote,
      base: data.base,
    },
    {
      cacheConfig: {
        useCache: true,
        maxAge: 1000 * 60 * 60,
      },
    },
  );
};
